import { PaymentAgreementListModel, PaymentAgreenentModel } from '../../../common/src';
import * as backendApi from '../shared/backend-api';
export default class PaymentAgreementService {
  constructor() {}

  getPersonActiveValidPaymentsAgreement(selectedUserId: number, selectedUserCenterId: number): Promise<PaymentAgreementListModel> {
    return backendApi.post('payment-agreement/get-person-active-valid-payments-agreements', { selectedUserId, selectedUserCenterId });
  }
}
